// libs
import React, { memo } from 'react';

import { Container } from './styles';

// def
import { WidgetTitleProps } from './types';

function WidgetSubTitle({ title, alignment }: WidgetTitleProps) {
  return <Container alignment={alignment}>{title}</Container>;
}

export default memo(WidgetSubTitle);
